import type { FC, SVGProps } from 'react'

export const PlayNextArrow: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3056 5C16.922 5 16.6111 5.31091 16.6111 5.69444V11.0606L7.25181 5.95553C6.46244 5.52497 5.5 6.0963 5.5 6.99547V18.0045C5.5 18.9037 6.46244 19.475 7.25181 19.0445L16.6111 13.9394V19.3056C16.6111 19.6891 16.922 20 17.3056 20C17.6891 20 18 19.6891 18 19.3056V5.69444C18 5.31091 17.6891 5 17.3056 5Z"
      fill="currentColor"
    />
  </svg>
)
